module.exports = __webpack_public_path__ + "31081aac08e4d1c4707176b9c20c5aab.gltf";